import React from 'react'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { EventActions } from '@utils/analytics/types'
import { sendConfiguratorGADownloadEvent } from '@utils/analytics/configuratorAnalytics'

const useStyles = makeStyles((theme: Theme) => {
  return {
    multiProductTemplateIcon: {
      color: theme.palette.primary.main,
    },
    multiProductTemplateText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1),
    },
    multiProductTemplateButton: {
      padding: 2,
      borderRadius: 0,
      '&:hover': {
        background: 'none',
        textDecoration: 'underline',
      },
    },
  }
})

interface DownloadsItem {
  label: React.ReactNode
  isPCR: boolean
  fileName: string
  productType: string
}

interface DownloadsItemProps {
  items: DownloadsItem
}

const DownloadTemplate: React.FC<DownloadsItemProps> = ({ items }) => {
  const classes = useStyles()
  return (
    <IconButton
      className={classes.multiProductTemplateButton}
      onClick={() =>
        sendConfiguratorGADownloadEvent(
          EventActions.Templates,
          `${items.productType}`
        )
      }
      href={`/static/configurator/${items.fileName}`}
      download={items.fileName}
    >
      <CloudDownloadIcon className={classes.multiProductTemplateIcon} />
      <div
        className={classes.multiProductTemplateText}
        data-testid="semi-configurator_download-file-template"
      >
        {items.label}
      </div>
    </IconButton>
  )
}

export default DownloadTemplate
